import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendEventToBackend } from "../Utilities/sendEventToBackend";

export default function GTMPageView(props) {
  const {token} = props;
  const location = useLocation();

  // useEffect(() => {
  //     window.dataLayer = window.dataLayer || [];
  //     window.dataLayer.push({
  //         event: "react_page_view_bc",
  //         page_path: location.pathname + location.search,
  //         page_title: document.title,
  //         debug_mode: true,
  //         page_location: window.location.href
  //     });
  // }, [location]);
  useEffect(() => {
    sendEventToBackend("bc_page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    }, token);
  }, [location]);

  return null;
}
